var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './MonthPicker.module.scss';
import { v4 as uuid } from 'uuid';
import { MONTHS } from '../../../../constants';
import { addMonths, subMonths, getMonth, getYear, setYear, monthsInYear, addYears } from 'date-fns';
import { Dropdown } from '../../../Dropdown/Dropdown';
import { ArrowLeft, ArrowRight } from '../../../../assets/icons';
var MonthPicker = function (_a) {
    var months = _a.months, focusDate = _a.focusDate, onChange = _a.onChange, minDate = _a.minDate, maxDate = _a.maxDate;
    var addOneMonth = function () { return onChange(addMonths(focusDate, 1)); };
    var subOneMonth = function () { return onChange(subMonths(focusDate, 1)); };
    var checkIsYearDisabled = function (year, min, max) {
        var start = min ? getYear(min) : 1970;
        var end = max ? getYear(max) : 3000;
        return year < start || year > end;
    };
    var getYears = function (length) {
        var result = [];
        var firstYear = maxDate ? getYear(addYears(maxDate, 1)) : getYear(addYears(new Date(), 5));
        for (var index = 0; index < length; index++) {
            var value = firstYear - index;
            var isDisabled = checkIsYearDisabled(value, minDate, maxDate);
            result.push({
                label: value.toString(),
                value: value.toString(),
                isDisabled: isDisabled,
            });
        }
        return result;
    };
    var years = getYears(25);
    var getSelectedMonth = function (i) {
        return MONTHS.find(function (m) { return parseInt(m.value) === (getMonth(focusDate) + i + monthsInYear) % monthsInYear; });
    };
    var getSelectedYear = function (i) {
        var increment = getMonth(focusDate) + i >= monthsInYear ? 1 : 0;
        return years.find(function (y) { return parseInt(y.value) === getYear(focusDate) + increment; });
    };
    var onMonthChange = function (value, i) {
        var current = (getMonth(focusDate) + i + monthsInYear) % monthsInYear;
        if (value > current)
            onChange(addMonths(focusDate, value - current));
        if (value < current)
            onChange(subMonths(focusDate, current - value));
    };
    var onYearChange = function (value, i) {
        var decrement = getMonth(focusDate) + i >= monthsInYear ? 1 : 0;
        onChange(setYear(focusDate, value - decrement));
    };
    var renderMultiple = function (renderComponent) {
        return Array.from({ length: months || 1 }).map(function (m, i) { return renderComponent(i); });
    };
    var renderSelects = function (i) { return (_jsxs("section", __assign({ className: styles.SelectGroup }, { children: [_jsx(Dropdown, { small: true, smallText: true, noMargin: true, showSelected: true, label: '', selected: getSelectedMonth(i), options: MONTHS, dataId: "focus-month-".concat(i + 1), onChange: function (m) { return onMonthChange(parseInt(m.value), i); } }), _jsx(Dropdown, { small: true, smallText: true, noMargin: true, showSelected: true, label: '', selected: getSelectedYear(i), options: years, dataId: "focus-year-".concat(i + 1), onChange: function (y) { return onYearChange(parseInt(y.value), i); } })] }), uuid())); };
    var onSelectsRender = useMemo(function () { return renderMultiple(renderSelects); }, [focusDate]);
    return (_jsxs("section", __assign({ className: styles.MonthPicker }, { children: [_jsx("i", __assign({ className: styles.Arrow, "data-testid": 'sub-month', onClick: subOneMonth }, { children: _jsx(ArrowLeft, {}) })), _jsx("section", __assign({ className: styles.MonthSelects }, { children: onSelectsRender })), _jsx("i", __assign({ className: styles.Arrow, "data-testid": 'add-month', onClick: addOneMonth }, { children: _jsx(ArrowRight, {}) }))] })));
};
MonthPicker.propTypes = {
    months: PropTypes.number,
    onChange: PropTypes.func.isRequired,
};
export { MonthPicker };
//# sourceMappingURL=MonthPicker.js.map